import { bindable, BoundViewFactory, templateController, ViewSlot } from 'aurelia-templating';
import { autoinject } from "aurelia-dependency-injection";

@autoinject()
@templateController()
export class AnimatableJsIfCustomAttribute {

    @bindable
    public animation: JsAnimation = null;

    @bindable
    public selector: string = null;

    @bindable
    public value: boolean = true;

    private bindingContext: any = null;
    private overrideContext: any = null;
    private view: any = null;
    private showing: boolean = false;

    private funcOut: any;

    constructor(private viewFactory: BoundViewFactory, private viewSlot: ViewSlot) {
    }

    bind(bindingContext, overrideContext) {
        this.bindingContext = bindingContext;
        this.overrideContext = overrideContext;
        this.valueChanged(this.value);
    }

    valueChanged(newValue) {
        let viewOrPromise = void 0;
        if (!newValue) {
            if (this.view !== null && this.showing) {
                if (this.animation) {
                    this.funcOut = () => {
                        if (this.view) {
                            this.funcOut = null;
                            viewOrPromise = this.viewSlot.remove(this.view, false, true);
                            viewOrPromise.unbind();
                        }
                    };
                    this.animation.cancelOn($(this.view.firstChild).find(this.selector));
                    this.animation.off($(this.view.firstChild).find(this.selector)).then(() => {
                        this.funcOut();
                    });
                }
            }
            this.showing = false;
        } else {
            if (this.funcOut) {
                this.funcOut = null;
                this.animation.cancelOff($(this.view.firstChild).find(this.selector));
                if ((<any>this.viewSlot).children.length > 0) {
                    viewOrPromise = this.viewSlot.remove(this.view, false, true);
                    viewOrPromise.unbind();
                }
            }
            if (this.view === null) {
                this.view = this.viewFactory.create();
            }

            if (!this.view.isBound) {
                this.view.bind(this.bindingContext, this.overrideContext);
            }

            if (!this.showing) {
                this.showing = true;
                this.viewSlot.add(this.view);
                if (this.animation) {
                    this.animation.on($(this.view.firstChild).find(this.selector));
                }
            }
        }
    }

    unbind() {
        if (this.view === null) {
            return;
        }

        this.view.unbind();

        if (this.funcOut && !this.value) {
            this.view.firstChild.removeEventListener("animationend", this.funcOut, false);
            if (this.view.firstChild.classList.contains("au-leave-active")) {
                (this.view.firstChild).classList.remove("au-leave-active");
            }
            this.funcOut = null;
            if ((<any>this.viewSlot).children.length > 0) {
                const viewOrPromise: any = this.viewSlot.remove(this.view, false, true);
                viewOrPromise.unbind();
            }
        }

        if (!this.viewFactory.isCaching) {
            return;
        }

        if (this.showing) {
            this.showing = false;
            this.viewSlot.remove(this.view, true, true);
        }

        this.view.returnToCache();
        this.view = null;
        this.bindingContext = null;
        this.overrideContext = null;
    }
}

export interface JsAnimation {
    on: (el) => Promise<void>;
    off: (el) => Promise<void>;
    cancelOn: (el) => void;
    cancelOff: (el) => void;
}
